import ReportClientSelectorComponent from './report-client-selector-component'

/***
 * A client selector with a built-in callback for the button that pops up which takes the user to the given
 * report page state.
 */
const reportClientSelector = angular
    .module('FacilityData.Common.ReportClientSelector', [])
    .component('reportClientSelector', ReportClientSelectorComponent)
    .name;

export default reportClientSelector;


// WEBPACK FOOTER //
// ./app/common/report-client-selector/report-client-selector.js